/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeTriangleADownIcon16Light } from './ArrowShapeTriangleADownIcon16Light';
import { ArrowShapeTriangleADownIcon16Regular } from './ArrowShapeTriangleADownIcon16Regular';
import { ArrowShapeTriangleADownIcon16Solid } from './ArrowShapeTriangleADownIcon16Solid';
import { ArrowShapeTriangleADownIcon20Light } from './ArrowShapeTriangleADownIcon20Light';
import { ArrowShapeTriangleADownIcon20Regular } from './ArrowShapeTriangleADownIcon20Regular';
import { ArrowShapeTriangleADownIcon20Solid } from './ArrowShapeTriangleADownIcon20Solid';
import { ArrowShapeTriangleADownIcon24Regular } from './ArrowShapeTriangleADownIcon24Regular';
import { ArrowShapeTriangleADownIcon24Solid } from './ArrowShapeTriangleADownIcon24Solid';
import { ArrowShapeTriangleADownIcon32Regular } from './ArrowShapeTriangleADownIcon32Regular';
import { ArrowShapeTriangleADownIcon64Regular } from './ArrowShapeTriangleADownIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeTriangleADownIcon16Light,
        regular: ArrowShapeTriangleADownIcon16Regular,
        solid: ArrowShapeTriangleADownIcon16Solid,
    },
    20: {
        light: ArrowShapeTriangleADownIcon20Light,
        regular: ArrowShapeTriangleADownIcon20Regular,
        solid: ArrowShapeTriangleADownIcon20Solid,
    },
    24: {
        regular: ArrowShapeTriangleADownIcon24Regular,
        solid: ArrowShapeTriangleADownIcon24Solid,
    },
    32: {
        regular: ArrowShapeTriangleADownIcon32Regular,
    },
    64: {
        regular: ArrowShapeTriangleADownIcon64Regular,
    },
};
export var ArrowShapeTriangleADownIcon = forwardRef('ArrowShapeTriangleADownIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
